module.exports = __webpack_public_path__ + "static/img/thumb_voucher-preview.eeda902.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/voucher/thumb_voucher-preview.jpg
// module id = 60
// module chunks = 0